
// 加载百度地图js
export function map(){
  const AK = 'enhgM7N9Mf0UYoC1YyV63YlFIdvnG4iq';
  const BMap_URL = "https://api.map.baidu.com/api?type=webgl&v=1.0&ak="+AK+"&callback=onBMapCallback";
	return new Promise((resolve, reject) => {
		// 如果已加载直接返回
		if(typeof BMapGL !== "undefined") {
				resolve(BMapGL);
				return true;
		}
	
		window.onBMapCallback = function() {
				resolve(BMapGL);
		}
		
		// 插入script脚本
		let scriptNode = document.createElement("script");
		scriptNode.setAttribute("type", "text/javascript");
		scriptNode.setAttribute("src", BMap_URL);
		scriptNode.setAttribute("resolve", resolve);
		scriptNode.setAttribute("reject", reject)
		document.body.appendChild(scriptNode);
	});
}

// 下载文件
export function commonUpdateFile(url, fileName) {
	var xhr = new XMLHttpRequest();
	xhr.open('GET', url, true);
	xhr.setRequestHeader("X-Authorization", localStorage.getItem('token'));
	xhr.responseType = 'blob';
	xhr.onload = function (e) {
		//如果请求执行成功
		if (this.status == 200) {
				var blob = this.response;
				var a = document.createElement('a');

				// blob.type = "application/octet-stream";
				//创键临时url对象
				var url = URL.createObjectURL(blob);

				a.href = url;
				a.download=fileName;
				a.click();
				//释放之前创建的URL对象
				window.URL.revokeObjectURL(url);
		}
	};
	//发送请求
	xhr.send();
}